import { render, staticRenderFns } from "./ErpCategories.vue?vue&type=template&id=82e858e0&"
import script from "./ErpCategories.vue?vue&type=script&lang=js&"
export * from "./ErpCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports